import { render, staticRenderFns } from "./PageSkeleton.vue?vue&type=template&id=a5444f9a&scoped=true"
var script = {}
import style0 from "./PageSkeleton.vue?vue&type=style&index=0&id=a5444f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5444f9a",
  null
  
)

export default component.exports